import { render, staticRenderFns } from "./SfDivider.vue?vue&type=template&id=074d52dd&"
import script from "./SfDivider.vue?vue&type=script&lang=js&"
export * from "./SfDivider.vue?vue&type=script&lang=js&"
import style0 from "./SfDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports